import React from "react";
import { Link, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import llmLogo from "../assets/images/llmIcon.png";

const Landing = () => {
  const { currentUser } = useAuth();

  // Redirect to dashboard if already logged in
  if (currentUser) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="landing-page-container">
      <div className="landing-page-content">
        {/* Hero Section */}
        <div className="landing-hero">
          <div className="landing-page-logo">
            <img src={llmLogo} alt="Local Live Music Logo" />
          </div>

          <h1 className="landing-page-title neon-glow">Local Live Music</h1>
          <div className="landing-page-subtitle">Booking Platform</div>
          <p className="landing-page-tagline">
            Connect venues with artists. Book live music experiences
          </p>

          <div className="landing-page-cta-buttons">
            <Link to="/signup" className="landing-cta-btn landing-cta-primary">
              Get Started
            </Link>
            <Link to="/login" className="landing-cta-btn landing-cta-secondary">
              Sign In
            </Link>
          </div>
        </div>

        {/* Features Grid */}
        <div className="landing-features-grid">
          <div className="landing-feature-card">
            <div className="landing-feature-icon">🎵</div>
            <h3 className="landing-feature-title">Artist Discovery</h3>
            <p className="landing-feature-description">
              Find and book talented local artists for your venue with our
              extensive artist directory
            </p>
          </div>

          <div className="landing-feature-card">
            <div className="landing-feature-icon">🏪</div>
            <h3 className="landing-feature-title">Venue Management</h3>
            <p className="landing-feature-description">
              Manage multiple venues, customize time slots, and track all your
              bookings in one place
            </p>
          </div>

          <div className="landing-feature-card">
            <div className="landing-feature-icon">📅</div>
            <h3 className="landing-feature-title">Smart Scheduling</h3>
            <p className="landing-feature-description">
              Calendar view with real-time availability and conflict prevention
              for seamless booking
            </p>
          </div>

          <div className="landing-feature-card">
            <div className="landing-feature-icon">💰</div>
            <h3 className="landing-feature-title">Financial Tracking</h3>
            <p className="landing-feature-description">
              Track earnings, tips, and sales with detailed financial reports
              and analytics
            </p>
          </div>

          <div className="landing-feature-card">
            <div className="landing-feature-icon">💬</div>
            <h3 className="landing-feature-title">Real-Time Messaging</h3>
            <p className="landing-feature-description">
              Direct communication between artists and venues with instant
              notifications
            </p>
          </div>

          <div className="landing-feature-card">
            <div className="landing-feature-icon">📊</div>
            <h3 className="landing-feature-title">Performance Analytics</h3>
            <p className="landing-feature-description">
              Compare artist performance, track engagement, and make data-driven
              booking decisions
            </p>
          </div>

          <div className="landing-feature-card">
            <div className="landing-feature-icon">👥</div>
            <h3 className="landing-feature-title">Team Collaboration</h3>
            <p className="landing-feature-description">
              Invite bar admins to help manage your venues with role-based
              access control
            </p>
          </div>

          <div className="landing-feature-card">
            <div className="landing-feature-icon">🎤</div>
            <h3 className="landing-feature-title">Artist Profiles</h3>
            <p className="landing-feature-description">
              Showcase your music with complete profiles, social links, and
              availability calendar
            </p>
          </div>

          <div className="landing-feature-card">
            <div className="landing-feature-icon">🔔</div>
            <h3 className="landing-feature-title">Smart Notifications</h3>
            <p className="landing-feature-description">
              Stay updated with booking confirmations, cancellations, and
              important updates
            </p>
          </div>
        </div>

        {/* Footer CTA */}
        <div className="landing-footer-cta">
          <h2 className="landing-footer-title">Ready to get started?</h2>
          <p className="landing-footer-text">
            Join the local live music community today
          </p>
          <Link to="/signup" className="landing-cta-btn landing-cta-primary">
            Create Your Free Account
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Landing;
